import { getAssignmentById, updateAssignment } from '../../../service';
import { mergeTaskCourseMaterialsIntoQuestions } from '../../CreateNewTask/utils/taskCourseMaterialsMerge';

export const saveBatchCourseMaterials = async (assignmentId, materials) => {
  if (!Array.isArray(materials)) return;
  const assignment = await getAssignmentById(assignmentId);
  if (!assignment?.id || !assignment.questions?.length) {
    throw new Error('This draft could not be loaded. Please try again.');
  }
  const questions = mergeTaskCourseMaterialsIntoQuestions(assignment.questions, materials);
  if (JSON.stringify(questions) === JSON.stringify(assignment.questions)) return;
  const saved = await updateAssignment(assignmentId, { ...assignment, questions }, { throwOnError: true });
  if (!saved) throw new Error('Your course materials could not be attached. Please try again.');
};
